/**
 * Business logic per Profit Centers autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import profitCentersService from '../services/profitCentersService';
import type { ProfitCenterAutocompleteResult } from '../models/profitCenter';
import type { BaseAutocompleteOptions, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export async function getProfitCentersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: BaseAutocompleteOptions = {},
): Promise<ProfitCenterAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		select: 'id,code,name',
		count: true,
		top: 20,
		orderBy: ['code'],
		filter: {
			and: [{ isDisabled: { eq: false } }],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(name)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [{ id: { in: notInIds } }],
		});
	}

	const result = await profitCentersService.getProfitCenters(buildQuery(context));
	// OData select: id, code, name - type safety garantita da Pick<>
	return result.value;
}
